import React from 'react';

// --- Data for the placement cards ---
const placementsData = [
  { 
    name: "Yawanth Sabbithi", 
    lpa: "19 LPA", 
    title: "Software Developer", 
    image: "https://skillsuprise.com/data/images/yahwanth.jpg" 
  },
  { 
    name: "Dadi Hemasri", 
    lpa: "12.5 LPA", 
    title: "Software Developer", 
    image: "https://skillsuprise.com/data/images/hemasri.png" 
  },
  { 
    name: "Sravani Suvvari", 
    lpa: "12 LPA", 
    title: "DevOps Engineer", 
    image: "https://skillsuprise.com/data/images/sravani.jpg" 
  },
  { 
    name: "Saif Khan", 
    lpa: "10 LPA", 
    title: "Associate Developer", 
    image: "https://skillsuprise.com/data/images/saif.png" 
  },
  { 
    name: "Sowmya Chaganti", 
    lpa: "7 LPA", 
    title: "Software Developer", 
    image: "https://skillsuprise.com/data/images/sowmyachaganti.jpg" 
  },
  { 
    name: "Swetha Sri", 
    lpa: "7 LPA", 
    title: "Software Engineer", 
    image: "https://skillsuprise.com/data/images/swethasri.jpg" 
  },
  { 
    name: "Amulya Sree", 
    lpa: "6.5 LPA", 
    title: "SOC Engineer", 
    image: "https://skillsuprise.com/data/cyberPDF/placements/amulya.png"
  },
  { 
    name: "Santosh", 
    lpa: "6 LPA", 
    title: "Cyber Security Analyst", 
    image: "https://skillsuprise.com/data/cyberPDF/placements/sonthosh.png"
  },
  { 
    name: "Manidhar", 
    lpa: "7 LPA", 
    title: "Cyber Security Analyst", 
    image: "https://skillsuprise.com/data/cyberPDF/placements/manindhar.png"
  },
];

// --- Internal CSS for all styling ---
const internalCSS = `
  /* --- Main Page Container --- */
  .placements-page-container {
    background-color: #fff;
    font-family: 'Poppins', sans-serif;
    padding: 4rem 1rem;
  }

  /* --- Title Section --- */
  .placements-title-section {
    text-align: center;
    margin-bottom: 3rem;
  }

  .placements-main-title {
    font-size: 3rem;
    font-weight: 600;
    color: #212529;
    margin-bottom: 0.75rem;
  }

  .title-decorator-placements {
    height: 4px;
    width: 100px;
    background: linear-gradient(to right, #a5d6a7, #198754, #a5d6a7);
    margin: 0 auto 1.5rem auto;
  }

  .placements-subtitle {
    font-size: 1.1rem;
    color: #0056b3;
    font-weight: 500;
  }

  /* --- Placements Grid Section --- */
  .placement-card {
    border: none;
    background-color: transparent;
    text-align: center;
    margin-bottom: 2rem;
  }

  .placement-img-wrapper {
    border-radius: 12px;
    overflow: hidden;
    margin-bottom: 1rem;
    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1);
    display: inline-block;
    background-color: #f1f5f9;
    
    border: 3px solid transparent;
  }

  .placement-img {
    display: block;
    width: 100%;
    /* Max-width and height are now more important */
    max-width: 200px;
    height: 150px; /* Shortened height to fit */
    object-fit: cover;
    border-radius: 8px;
  }

  .placement-name {
    font-size: 1.2rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 0.25rem;
  }

  .placement-lpa {
    font-size: 1.5rem;
    font-weight: 800;
    color: #212529;
    margin-bottom: 0.25rem;
  }

  .placement-title {
    font-size: 0.9rem;
    color: #555;
  }

  /* --- Responsive Adjustments --- */
  @media (max-width: 991.98px) {
    .placements-main-title { 
      font-size: 2.5rem;
    }
  }

  @media (max-width: 767.98px) { /* Mobile Devices */
     .placements-main-title {
       font-size: 2rem;
     }
     .placements-subtitle {
       font-size: 1rem;
     }
     
     /* Add blue border on mobile */
     .placement-img-wrapper {
        border: 3px solid #004a99; /* Blue border */
        padding: 4px; /* Reduced padding for mobile */
     }
     
     .placement-img {
        height: 120px; /* Further reduced height for 3-col mobile */
     }

     /* FIX: Make text smaller for 3-col mobile */
     .placement-lpa {
       font-size: 1rem; /* Smaller LPA */
     }
     .placement-name {
       font-size: 0.9rem; /* Smaller name */
     }
     .placement-title {
       font-size: 0.75rem; /* Smaller title */
     }
  }
`;

const Placements = () => {
  return (
    <>
      <style>{internalCSS}</style>
      
      <div className="placements-page-container">
        
        {/* --- 1. Title Section --- */}
        <div className="placements-title-section">
          <h1 className="placements-main-title">Placements : 2023-24</h1>
          <div className="title-decorator-placements"></div>
          <p className="placements-subtitle">
            95% success rate in placements by our current batches
          </p>
        </div>
        
        {/* --- 2. Placements Grid Section --- */}
        <div className="placements-grid-section">
          <div className="container">
            
            {/* FIX: Changed to row-cols-3
              - row-cols-3: 3 columns on ALL screen sizes (mobile and desktop)
              - g-3: Reduced gutter
            */}
            <div className="row row-cols-3 g-3">
              
              {placementsData.map((placement, index) => (
                <div className="col" key={index}>
                  <div className="placement-card">
                    <div className="placement-img-wrapper">
                      <img src={placement.image} alt={placement.name} className="placement-img" />
                    </div>
                    <h5 className="placement-name">{placement.name}</h5>
                    <p className="placement-lpa">{placement.lpa}</p>
                    <p className="placement-title">{placement.title}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        
      </div>
    </>
  );
};

export default Placements;